(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bam-tee-pair"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('bam-tee-pair')) return;
  class BamTeePair extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      const config = this.querySelector('[data-pair-config]');
      if (!config) return;
      try { this.config = JSON.parse(config.textContent); } catch (_) { return; }
      this.scope = this.closest('[data-section-type="product-section"]');
      if (!this.scope) return;
      this.primary = this.config.primary;
      this.words = this.config.text;
      if (!this.words || typeof this.words !== 'object') return;
      const ids = new Set([this.primary.id]);
      this.products = this.config.products.filter(p => {
        if (!p || ids.has(p.id) || !p.image || !p.variants.some(v => v.available)) return false;
        ids.add(p.id); return true;
      }).slice(0,8);
      if (!this.products.length) return;
      this.ready = true;
      this.primaryVariant = this.primary.variants.find(v => v.id === this.config.selected) || this.primary.variants[0];
      const pairs = {
        'halloween-dont-go-to-hospital-short-sleeve-t-shirt':'never-enjoy-halloween-short-sleeve-t-shirt',
        'never-enjoy-halloween-short-sleeve-t-shirt':'never-enjoy-anything-limited-edition-tshirt',
        'never-enjoy-anything-limited-edition-tshirt':'halloween-dont-go-to-hospital-short-sleeve-t-shirt'
      };
      this.partner = this.products.find(p => p.handle === pairs[this.primary.handle]) || this.products[0];
      this.matchSize = true;
      this.busy = false;
      this.uncertain = false;
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      this.singleButton = this.scope.querySelector('.product__section-content__block--buttons .js-ajax-submit');
      this.singleForm = this.singleButton?.closest('form');
      if (this.hasAttribute('data-pair-stacked-controls') && this.singleForm && !this.contains(this.singleForm)) {
        this.singleFormPlaceholder = document.createComment('');
        this.singleForm.before(this.singleFormPlaceholder);
        this.querySelector('[data-pair-add]').after(this.singleForm);
        this.classList.add('bam-pair--stacked-controls');
      }
      this.scope.classList.add('bam-pair-ready');
      this.scope.querySelectorAll('[name="quantity"]').forEach(input => { input.value = '1'; });
      this.addEventListener('click', e => this.onClick(e), opts);
      this.querySelector('[data-pair-match]').addEventListener('change', e => {
        this.matchSize = e.target.checked;
        this.renderPartner();
      }, opts);
      this.querySelector('[data-pair-variant]').addEventListener('change', e => {
        this.matchSize = false;
        this.partnerVariant = this.partner.variants.find(v => String(v.id) === e.target.value) || null;
        this.renderPrices();
      }, opts);
      this.scope.addEventListener('change', e => {
        if (this.contains(e.target)) return;
        if (e.target.matches('.formVariantId, .js-qty-input') || e.target.closest('.js-variant-selector')) {
          queueMicrotask(() => this.syncPrimary());
        }
      }, opts);
      this.scope.addEventListener('click', e => {
        if (e.target.closest('.js-variant-selector')) queueMicrotask(() => this.syncPrimary());
      }, opts);
      this.scope.addEventListener('click', e => {
        if (!e.target.closest('.js-ajax-submit')) return;
        if (this.busy || this.uncertain) { e.preventDefault(); e.stopImmediatePropagation(); }
      }, {capture:true, signal:this.abort.signal});
      window.addEventListener('popstate', () => this.syncPrimary(), opts);
      this.hidden = false;
      this.renderPartner();
      this.syncPrimary();
      this.setupSticky();
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect();
      if (this.singleFormPlaceholder?.parentNode && this.singleForm) this.singleFormPlaceholder.replaceWith(this.singleForm);
      this.singleFormPlaceholder = null;
      this.classList.remove('bam-pair--stacked-controls');
      this.scope?.classList.remove('bam-pair-ready');
      document.body.classList.remove('bam-pair-mobile-space');
      this.ready = false;
    }
    t(key, replacements = {}) {
      return Object.entries(replacements).reduce((s,[k,v]) => s.replaceAll(`{${k}}`,v), this.words[key] || key);
    }
    money(cents, compact = false) {
      return new Intl.NumberFormat(this.config.locale || 'en-US',{style:'currency',currency:this.config.currency,...(compact ? {minimumFractionDigits:0,maximumFractionDigits:2} : {})}).format(cents/100);
    }
    discountCents() {
      const amount=Number(this.config.discountAmount);
      if (!this.config.discountActive || !Number.isFinite(amount) || amount<=0) return 0;
      if (this.config.currency===this.config.shopCurrency) return Math.round(amount);
      const currency=window.Shopify?.currency;
      const rate=Number(currency?.rate);
      return currency?.active===this.config.currency && Number.isFinite(rate) && rate>0 ? Math.round(amount*rate) : 0;
    }
    put(selector, value) { const el = this.querySelector(selector); if (el) el.textContent = value; }
    sizeOf(product, variant) {
      const i = product.options.findIndex(name => /^(size|sizes)$/i.test(name));
      return i >= 0 && variant ? variant.options[i] : null;
    }
    matchVariant() {
      const size = this.sizeOf(this.primary,this.primaryVariant);
      const sizeIndex = this.partner.options.findIndex(name => /^(size|sizes)$/i.test(name));
      const pool = this.partner.variants.filter(v => v.available && (sizeIndex < 0 || !size || v.options[sizeIndex] === size));
      const colorIndex = this.partner.options.findIndex(name => /^(color|colour)$/i.test(name));
      return pool.find(v => colorIndex >= 0 && /^black$/i.test(v.options[colorIndex])) || pool[0] || null;
    }
    syncPrimary() {
      const groups = [...this.scope.querySelectorAll('.js-variant-selector')];
      let options = groups.map(g => g.tagName === 'SELECT' ? g.value : g.querySelector('input:checked')?.value);
      if (options.length) this.primaryVariant = this.primary.variants.find(v => v.options.every((o,i) => o === options[i])) || null;
      else {
        const id = this.scope.querySelector('.formVariantId')?.value || this.config.selected;
        this.primaryVariant = this.primary.variants.find(v => String(v.id) === String(id)) || null;
      }
      this.put('[data-pair-first-size]', this.primaryVariant?.title === 'Default Title' ? '' : this.primaryVariant?.title || this.t('unavailable'));
      if (this.matchSize) this.partnerVariant = this.matchVariant();
      this.renderPrices();
    }
    renderPartner() {
      this.put('[data-pair-title]',this.partner.title);
      const image = this.querySelector('[data-pair-image]');
      image.src = this.partner.image; image.alt = this.partner.title;
      this.partnerVariant = this.matchVariant();
      if (!this.matchSize && !this.partnerVariant) this.partnerVariant = this.partner.variants.find(v => v.available) || null;
      const select = this.querySelector('[data-pair-variant]');
      select.replaceChildren(new Option(this.t('choose_size'),''));
      this.partner.variants.forEach(v => {
        const option = new Option(v.title + (!v.available ? ` — ${this.t('sold_out')}` : ''),v.id);
        option.disabled = !v.available; select.add(option);
      });
      const choices = this.querySelector('[data-pair-choices]'); choices.replaceChildren();
      this.products.forEach(p => {
        const button = document.createElement('button'); button.type='button'; button.className='bam-pair__choice';
        button.dataset.pairProduct=String(p.id); button.setAttribute('aria-pressed',String(p.id===this.partner.id));
        const img=document.createElement('img'); img.src=p.image; img.alt=''; img.width=100; img.height=88; img.loading='lazy';
        const label=document.createElement('span'); label.textContent=p.title;
        button.append(img,label); choices.append(button);
      });
      this.renderPrices();
    }
    renderPrices() {
      const first=this.primaryVariant, second=this.partnerVariant;
      const base=(first?.price || 0)+(second?.price || 0);
      const saving=first && second ? Math.min(base,this.discountCents()) : 0;
      const total=base-saving;
      const percent=base>0 ? Math.floor(saving*100/base) : 0;
      const valid=!!(first?.available && second?.available);
      const shipping=valid && this.config.country==='US' && this.config.currency==='USD' && total>=this.config.shippingThreshold;
      const offer=valid && saving>0;
      this.put('[data-pair-heading]',offer ? this.t('heading_offer',{price:this.money(second.price-saving,true)}) : this.t('heading'));
      const size=this.sizeOf(this.primary,first);
      this.put('[data-pair-matched-size]',size ? `(${size})` : '');
      this.querySelector('[data-pair-match]').checked=this.matchSize;
      this.querySelector('[data-pair-variant-wrap]').hidden=this.matchSize && !!second;
      this.querySelector('[data-pair-variant]').value=second ? String(second.id) : '';
      const missingMatch=this.matchSize && !second && !!first;
      this.querySelector('[data-pair-notice]').hidden=!missingMatch;
      this.put('[data-pair-notice]',this.t('size_missing',{size:size || ''}));
      this.put('[data-pair-price]',valid ? this.money(total) : this.t('choose_size'));
      this.put('[data-pair-item-price]',second ? this.t('second_price',{price:this.money(second.price-saving)}) : this.t('choose_size'));
      this.put('[data-pair-was]',this.money(base)); this.querySelector('[data-pair-was]').hidden=!saving || !valid;
      this.put('[data-pair-saving]',this.t('save',{saving:this.money(saving)})); this.querySelector('[data-pair-saving]').hidden=!saving || !valid;
      this.put('[data-pair-badge]',this.t('free_shipping')); this.querySelector('[data-pair-badge]').hidden=!shipping;
      this.put('[data-pair-intro]',offer ? this.t(shipping ? 'intro_offer_shipping' : 'intro_offer',{saving:this.money(saving)}) : this.t(shipping ? 'intro_shipping' : 'intro'));
      this.put('[data-pair-foot]',this.t(shipping ? 'foot_shipping' : 'foot'));
      const button=this.querySelector('[data-pair-add]');
      button.disabled=!valid || this.busy || this.uncertain;
      const buttonKey=offer && percent>0 ? (shipping ? 'add_both_offer_shipping' : 'add_both_offer') : (shipping ? 'add_both_shipping' : 'add_both');
      button.textContent=this.busy ? this.t('adding') : this.uncertain ? this.t('review_cart') : valid ? this.t(buttonKey,{percent,price:this.money(total)}) : this.t(first?.available ? 'choose_second_size' : 'unavailable');
      if (this.singleButton) {
        if (!this.busy && !this.uncertain) this.singleButton.disabled=!first?.available;
        this.singleButton.value=first?.available ? this.t('just_one',{price:this.money(first.price)}) : this.t('sold_out');
      }
      this.put('[data-pair-sticky-price]',valid ? `· ${this.money(total)}` : '');
      this.put('[data-pair-sticky-detail]',offer ? this.t(shipping ? 'sticky_offer_shipping' : 'sticky_offer',{saving:this.money(saving)}) : this.t(shipping ? 'free_shipping' : 'swap_anytime'));
      this.querySelector('[data-pair-jump]').disabled=this.busy || this.uncertain;
    }
    onClick(event) {
      const button=event.target.closest('button'); if (!button || !this.contains(button)) return;
      if (button.hasAttribute('data-pair-add')) { event.preventDefault(); this.addPair(); }
      if (button.hasAttribute('data-pair-edit')) {
        this.matchSize=false; this.renderPrices(); this.querySelector('[data-pair-variant]').focus();
      }
      if (button.hasAttribute('data-pair-swap')) {
        const choices=this.querySelector('[data-pair-choices]'); choices.hidden=!choices.hidden;
        button.setAttribute('aria-expanded',String(!choices.hidden));
      }
      if (button.dataset.pairProduct) {
        this.partner=this.products.find(p=>String(p.id)===button.dataset.pairProduct); this.renderPartner();
        this.querySelector('[data-pair-choices]').hidden=true;
        const swap=this.querySelector('[data-pair-swap]'); swap.setAttribute('aria-expanded','false'); swap.focus();
      }
      if (button.hasAttribute('data-pair-jump')) {
        this.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
        this.querySelector('[data-pair-add]').focus({preventScroll:true});
      }
    }
    status(message, review=false) {
      const status=this.querySelector('[data-pair-status]'); status.hidden=!message; status.textContent=message;
      this.querySelector('[data-pair-review]').hidden=!review;
    }
    setupSticky() {
      if (!('IntersectionObserver' in window)) return;
      this.cartOpen=false;
      const update=()=>{
        const show=this.getBoundingClientRect().bottom<0 && !this.cartOpen;
        this.querySelector('[data-pair-sticky]').hidden=!show;
        document.body.classList.toggle('bam-pair-mobile-space',show);
      };
      this.observer=new IntersectionObserver(update,{threshold:0}); this.observer.observe(this);
      window.addEventListener('scroll',update,{passive:true,signal:this.abort.signal});
      window.addEventListener('resize',update,{passive:true,signal:this.abort.signal});
      const bind=()=>{
        if (typeof window.upcartSubscribeCartOpened==='function' && !this.cartSubscribed) {
          this.cartSubscribed=true;
          window.upcartSubscribeCartOpened(()=>{this.cartOpen=true;update();});
          window.upcartSubscribeCartClosed?.(()=>{this.cartOpen=false;update();});
        }
      };
      bind(); window.addEventListener('load',bind,{once:true,signal:this.abort.signal});
    }
    async revealCart() {
      if (typeof window.upcartOpenCart==='function') {
        try {
          if (typeof window.upcartRefreshCart==='function') await Promise.race([Promise.resolve(window.upcartRefreshCart()),new Promise(resolve=>setTimeout(resolve,4000))]);
          window.upcartOpenCart(); this.cartOpen=true; this.querySelector('[data-pair-sticky]').hidden=true; return;
        } catch (_) {}
      }
      window.location.assign(this.config.cartUrl);
    }
    async addPair() {
      if (this.busy || this.uncertain) return;
      this.syncPrimary();
      if (!this.primaryVariant?.available || !this.partnerVariant?.available) return;
      this.busy=true; this.status('');
      const controls=new Set([...this.querySelectorAll('button,input,select'),...this.scope.querySelectorAll('select.js-variant-selector,.js-variant-selector input,.js-variant-selector select,.js-ajax-submit')]);
      const disabledStates=new Map([...controls].map(el=>[el,el.disabled]));
      controls.forEach(el=>{el.disabled=true;});
      if(this.singleButton)this.singleButton.disabled=true;
      this.renderPrices();
      const items=[{id:this.primaryVariant.id,quantity:1},{id:this.partnerVariant.id,quantity:1}];
      const controller=new AbortController(); const timer=setTimeout(()=>controller.abort(),20000);
      let accepted=false;
      try {
        const response=await fetch(this.config.addUrl,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items}),signal:controller.signal});
        if (!response.ok) {
          this.uncertain=true;
          this.status(this.t('cart_error'),true);
          return;
        }
        accepted=true;
        this.status(this.t('added'),true);
        document.dispatchEvent(new CustomEvent('bam:pair-added',{detail:{productIds:[this.primary.id,this.partner.id],variantIds:items.map(item=>item.id),quantity:2}}));
        await this.revealCart();
      } catch (_) {
        if (accepted) { this.status(this.t('added'),true); }
        else { this.uncertain=true;this.status(this.t('network_error'),true); }
      } finally {
        clearTimeout(timer); this.busy=false;
        disabledStates.forEach((disabled,el)=>{el.disabled=disabled;});
        this.renderPrices();
      }
    }
  }
  customElements.define('bam-tee-pair',BamTeePair);
})();
  } catch(e) { console.error(e); }
})();

})();
